var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('h2',{staticStyle:{"font-weight":"bold"}},[_c('i',{class:_vm.icon + ' text-success py-2',staticStyle:{"margin-right":"15px"}}),_vm._v(" "+_vm._s(_vm.title))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e9bae14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/HeaderCard.vue
// module id = KlTD
// module chunks = 9